module.exports = __webpack_public_path__ + "media/Video 150.6c9d47e9.mp4";